import React, { useEffect, useRef, useState } from "react";
import classes from "./style.module.scss";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../component/Button";
import { Controller, FormProvider, useForm } from "react-hook-form";
import DateSelector from "../../component/DateSelector";
import TimePickerComponent from "../../component/TimePickerComponent";
import moment from "moment/moment";
import { createUserSlot } from "../../redux/reducers/adminSlice";
import { Toast } from "../../service/toast";
import { getUserTimeZone } from "../../helpers";
import InputBox from "../../component/InputBox";
import SelectBox from "../../component/SelectBox";
import RadioButton from "../../component/RadioButton";
import GetUserPermission from "../../component/GetUserPermission";
import { useNavigate } from "react-router-dom";

const CreateReport = (props) => {
  const { isOpen = false, closePopUp } = props;
  const [isEdit, setIsEdit] = useState(null);
  const selectBoxRef = useRef();
  const navigate = useNavigate();
  const addPermission = GetUserPermission({ key: 'add', microAppPath: 'rewards' });
  const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'rewards' });

  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    watch,
    setValue,
    trigger,
  } = formMethods;

  const selectedStartDate = watch("slotStartDate");
  const selectedEndDate = watch("slotEndDate");
  const selectedStartTime = watch("startTimeSelected");
  const selectedEndTime = watch("endTimeSelected");

  const radioOptions = [
    { value: "Customed Report", label: "Customed Report" },
    { value: "Scheduled Reports", label: "Scheduled Reports" },
  ];

  useEffect(() => {
    if (isEdit) {
      if (!editPermission) {
        closePopUp()
        redirectBack()
      }
    } else {
      if (!addPermission) {
        closePopUp()
        redirectBack()
      }
    }
  }, [isEdit])

  useEffect(() => {
    if (selectedStartTime && selectedEndTime) {
      const startTimeMoment = moment(selectedStartTime, "HH:mm A");
      const endTimeMoment = moment(selectedEndTime, "HH:mm A");
      if (startTimeMoment.isAfter(endTimeMoment)) {
        setValue("endTimeSelected", null);
      }
    }
  }, [selectedStartTime, selectedEndTime]);

  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      const startDateMoment = moment(selectedStartDate, "YYYY-MM-DD");
      const endDateMoment = moment(selectedEndDate, "YYYY-MM-DD");

      if (startDateMoment.isAfter(endDateMoment)) {
        setValue("slotEndDate", null);
      }
    }
  }, [selectedStartDate, selectedEndDate]);

  const redirectBack = () => {
    navigate(`/admin/report`);
  };

  const getInbetweenDates = (startDate, endDate, startTime, endTime) => {
    const ranges = [];
    let currentDay = moment.utc(startDate).startOf("day");
    const endDay = moment.utc(endDate).startOf("day");

    while (currentDay.isSameOrBefore(endDay)) {
      const startTimeDate = `${moment(currentDay)?.format(
        "YYYY-MM-DD"
      )}T${startTime?.split(" ")?.at(0)}:00${getUserTimeZone()}`;
      const endTimeDate = `${moment(currentDay)?.format("YYYY-MM-DD")}T${endTime
        ?.split(" ")
        ?.at(0)}:00${getUserTimeZone()}`;

      ranges.push({
        startTime: startTimeDate,
        endTime: endTimeDate,
      });

      currentDay.add(1, "day");
    }
    return ranges;
  };

  const onSubmit = (data) => {
    trigger();
    const dateValues = getInbetweenDates(
      data?.slotStartDate,
      data?.slotEndDate,
      data?.startTimeSelected,
      data?.endTimeSelected
    );

    createUserSlot(dateValues)
      .then((res) => {
        if (res?.data?.status) {
          Toast({
            type: "success",
            message: "Slot Created!",
          });
          closePopUp();
        }
      })
      .catch((err) => {
        console.log(err, "error");
        if (err?.response?.data?.message) {
          Toast({
            type: "error",
            message: err?.response?.data?.message,
          });
        } else {
          Toast({
            type: "error",
            message: "Unable to process the request!..",
          });
        }
      });
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.slotGeneratorWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>Create New Request</div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.slotFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`mt-5 ${classes.qrCardWrapper}`}>
                  <RadioButton
                    // radioValue={radioValue}
                    // onChange={handleRadioChange}
                    options={radioOptions}
                  />
                </div>
                <div className={`${classes.formField}`}>
                  <InputBox
                    label={"Report Name"}
                    className={`w-[100%]`}
                    name={"name"}
                    isEdit={isEdit ? true : false}
                    placeholder={"Name"}
                    {...register("name", {
                      required: true,
                    })}
                    error={errors.name}
                    messages={{
                      required: "Name is required",
                    }}
                  />
                </div>
                <div className={`${classes.formField}`}>
                  <Controller
                    name="status"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Report Type"
                        placeholder="Report Type"
                        // list={statusList}
                        isEdit={isEdit ? true : false}
                        {...field}
                        error={errors.status}
                        messages={{
                          required: "Report Type is required",
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`${classes.formGroup}`}>
                  <div className={`${classes.formField}`}>
                    <DateSelector
                      className={`w-[100%] ${classes.dateColumn}`}
                      name="slotStartDate"
                      control={formMethods.control}
                      error={errors.slotStartDate}
                      messages={{
                        required: "StartDate is required",
                        validate: "Date must be in YYYY-MM-DD format",
                      }}
                      minDate={moment().format("YYYY-MM-DD")}
                    />
                  </div>
                  <div className={`${classes.formField}`}>
                    <DateSelector
                      className={`w-[100%] ${classes.endDate}`}
                      name="slotEndDate"
                      placeholder="Choose a date"
                      control={formMethods.control}
                      error={errors.slotEndDate}
                      messages={{
                        required: "EndDate is required",
                        validate: "Date must be in YYYY-MM-DD format",
                      }}
                      minDate={
                        selectedStartDate
                          ? moment(selectedStartDate).format("YYYY-MM-DD")
                          : null
                      }
                    />
                  </div>
                </div>
                <div className="flex justify-end">
                  <Button
                    text={"Generate Report"}
                    className={`w-[100%] my-4`}
                    smallBtn
                  />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default CreateReport;
